import React, { useState } from "react";
import { ToggleButton, ToggleButtonGroup, Box, Typography, Stack } from "@mui/material";
import { enqueueSnackbar } from "notistack";


const formatTitle = (title) =>
    title ? title.replace(/[_]/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()) : title;

const ComparisonSettings = ({ CustomOptions, formik }) => {
    const [selectedTab, setSelectedTab] = useState("sale_date");
    const [disabledTabs, setDisabledTabs] = useState([]);

    const optionsList = [
        {
            // title: "Statis Columns 1",
            title: "Statistics Columns",
            options: ["avail_rooms", "sold_rooms", "ooo_rooms"],
            category: "statis1"
        },
        {
            title: "Custom Columns",
            // options: ["occupancy", "budget", "adr", "rev_par", "room_revenue", "other_revenue", "total_revenue"],
            options: ["occupancy", "adr", "rev_par", "room_revenue", "other_revenue", "total_revenue"],
            category: "custom",
            showSelect: true
        },
        // {
        //     title: "Comparison Columns",
        //     options: ["last_year", "budget"],
        //     category: "statis2"
        // }
    ];
    const variantsList = [
        "Show % and $ Variance along with LY / Budget values",
        "Show only % and $ Variance without LY / Budget values"
    ];

    const handleOptionClick = (category, key, value, active = false) => {
        // console.log(selectedTab)
        const optionKey = `${category}_${key}`;
        let currentOptions = { ...formik.values.column_settings[selectedTab] };

        if (
            category === "custom" &&
            formik.values.layout_settings.type === "Sale date / MTD / YTD - Side by side" &&
            Object.entries(currentOptions)
                .filter(([key, value]) => key.startsWith("custom_") && value)
                .length >= 3 &&
            !currentOptions[optionKey]
        ) {
            enqueueSnackbar(" Maximum Upto 2 Comparisions can be enabled for the selected Ranges", { variant: "warning" });
            return;
        }

        if (category === "custom") {
            if (value === undefined) {
                if (currentOptions[optionKey]) {
                    delete currentOptions[optionKey];
                } else {
                    currentOptions[optionKey] = "both";
                }
            } else {
                currentOptions[optionKey] = value;
            }
        } else {

            if (currentOptions[optionKey]) {
                delete currentOptions[optionKey];
            } else {
                currentOptions[optionKey] = true;
            }
        }
        if (
            (selectedTab === "sale_date" && !currentOptions["custom_sale_date"]) ||
            (selectedTab === "month_to_date" && !currentOptions["custom_month_to_date"]) ||
            (selectedTab === "year_to_date" && !currentOptions["custom_year_to_date"])
        ) {

            // currentOptions = {};
            const staticKeysMap = {
                sale_date: ["label", "display_date"],
                month_to_date: ["MonthFromDate", "MonthToDate"],
                year_to_date: ["YearFromDate", "YearToDate"]
            };

            const preserved = {};
            staticKeysMap[selectedTab]?.forEach((key) => {
                if (currentOptions[key]) {
                    preserved[key] = currentOptions[key];
                }
            });

            currentOptions = preserved;
        }

        formik.setFieldValue(`column_settings.${selectedTab}`, currentOptions);

        if (Object.values(currentOptions).filter(v => v === true).length === 2
            &&
            Object.values(currentOptions).filter(v => v === "both").length <= 1
            &&
            !Object.values(currentOptions).some(v => ["last_year", "budget", "actual"].includes(v))
            &&
            !active
        ) {
            // setDisabledTabs(prev => [...new Set([...prev, selectedTab])]);
            setDisabledTabs(prev => [...prev, selectedTab]);
        }
        else {
            setDisabledTabs(prev => prev.filter(tab => tab !== selectedTab));
        }
    };


    const isSelected = (key) => !!formik.values.column_settings[selectedTab]?.[`custom_${key}`];

    return (
        <Box width="100%">
            {/* Toggle Buttons */}
            <Stack mt={2} width={"50%"}>
                <ToggleButtonGroup
                    value={selectedTab}
                    exclusive
                    onChange={(e, newTab) => newTab && setSelectedTab(newTab)}
                    sx={{ borderRadius: "2px" }}
                >
                    {["sale_date", "month_to_date", "year_to_date"].map((key) => (
                        <ToggleButton
                            key={key}
                            value={key}
                            sx={{
                                border: "1px solid #009688",
                                height: "30px",
                                fontWeight: 400,
                                fontSize: "12px",
                                color: "#009688",
                                textTransform: "none",
                                "&.Mui-selected": { backgroundColor: "#C1F7E0" },
                            }}
                        >
                            {formatTitle(key)}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
            </Stack>

            <Box width="max-content">
                <Typography fontWeight={300} fontSize={10} marginBottom={1} marginTop={2}>
                    Enable Comparisons for
                </Typography>
                <CustomOptions
                    type={formatTitle(selectedTab)}
                    // selected={isSelected(selectedTab)}
                    selected={isSelected(selectedTab) && !disabledTabs.includes(selectedTab)}
                    onClick={() => handleOptionClick("custom", selectedTab, undefined, true)}
                />

                <Stack width="100%" direction="row" gap={10} mt={2} >
                    {optionsList.map(({ title, options, category, showSelect }) => (
                        <Box key={title}>
                            <Typography fontWeight={300} fontSize={10}>{title}</Typography>
                            <Stack mt={1} gap={2}>
                                {options.map((key) => (
                                    <CustomOptions
                                        key={(`${category}_${key}`)}
                                        type={key === "adr" ? "ADR" : key == "rev_par" ? "Rev PAR" : formatTitle(key)}
                                        selected={!!formik.values.column_settings[selectedTab]?.[`${category}_${key}`]}
                                        onClick={() => handleOptionClick(category, key, undefined)}
                                        showSelect={showSelect}
                                        // disabled={!isSelected(selectedTab)}
                                        disabled={!isSelected(selectedTab) || disabledTabs.includes(selectedTab)}
                                        selectedValue={
                                            category === "custom"
                                                ? formik.values.column_settings[selectedTab]?.[`${category}_${key}`] || ""
                                                : undefined
                                        }
                                        onSelectChange={(value) => handleOptionClick(category, key, value)}
                                    />
                                ))}
                            </Stack>
                        </Box>
                    ))}
                </Stack>
                {formik.values.layout_settings.type === "Sale date / MTD / YTD - Side by side" &&

                    <Typography color="red" fontSize={"8px"} mt={2}>
                        *** Maximum Upto 2 Comparisions can be enabled for the selected Ranges
                    </Typography>

                }
                {/* Variance Selection */}
                <Stack direction="column" mt={4} gap={2} width={"100%"}>
                    {variantsList.map((variant) => (
                        <CustomOptions
                            key={variant}
                            type={variant}
                            width={"500px"}
                            selected={formik.values.column_settings.ly_budget_values === variant}
                            // onClick={() => formik.setFieldValue("column_settings.ly_budget_values", variant)}
                            onClick={() => {
                                const current = formik.values.column_settings.ly_budget_values;
                                formik.setFieldValue(
                                    "column_settings.ly_budget_values",
                                    current === variant ? "" : variant
                                );
                            }}
                        />
                    ))}
                </Stack>
            </Box>

        </Box>
    );
};

export default ComparisonSettings;
